import { ProjectDetailsTab } from "@/data/models/ProjectDetailsTab";

/**
 * Tab items a phone shows before the rest moves under "Mehr". Apple's tab bar guidance: up to five
 * items; with more, four plus a "More" item that lists the others. Which tabs a project has depends
 * on its configuration (drying, portal-only conclusion, notes), so the split is computed per project.
 */
export const MAX_VISIBLE_PHONE_TABS = 5;

/** Icon of each project-detail tab in the phone tab bar; Projekt reuses the drawer's Projekte icon. */
export const PROJECT_DETAILS_TAB_ICONS: Record<ProjectDetailsTab, string> = {
  [ProjectDetailsTab.CLIENT_DATA]: "mdi-inbox",
  [ProjectDetailsTab.STATUS]: "mdi-timeline-text-outline",
  [ProjectDetailsTab.LOGBOOK]: "mdi-book-open-variant",
  [ProjectDetailsTab.DEVICES]: "mdi-view-dashboard",
  [ProjectDetailsTab.REPORTS]: "mdi-file-document-outline",
  [ProjectDetailsTab.CONCLUDE_PROJECT]: "mdi-flag-checkered",
  [ProjectDetailsTab.NOTES]: "mdi-note-text-outline",
  [ProjectDetailsTab.DOCUMENTS]: "mdi-folder-outline",
};

export interface PhoneTabSplit<T> {
  /** Shown as items of the bar, in order. */
  visible: T[];
  /** Listed under "Mehr"; empty when everything fits. */
  overflow: T[];
}

/**
 * Splits a project's tabs for the phone tab bar: all of them while they fit, otherwise the first
 * four and the rest under "Mehr", so the bar never shows more than five items.
 */
export function splitPhoneTabs<T>(tabs: T[], maxVisible = MAX_VISIBLE_PHONE_TABS): PhoneTabSplit<T> {
  if (tabs.length <= maxVisible) {
    return { visible: [...tabs], overflow: [] };
  }

  return { visible: tabs.slice(0, maxVisible - 1), overflow: tabs.slice(maxVisible - 1) };
}
